import { render, staticRenderFns } from "./BankAccountBankName.vue?vue&type=template&id=0688ac84&scoped=true&"
import script from "./BankAccountBankName.vue?vue&type=script&lang=js&"
export * from "./BankAccountBankName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688ac84",
  null
  
)

export default component.exports